import * as React from 'react';

import * as styles from './PrintPhone.css';
import { parsePhoneNumber } from '../../utils/strings';

interface IPrintPhoneProps {
  phone?: string | null;
}

export const PrintPhone: React.FC<IPrintPhoneProps> = ({ phone }) => {
  const parsedPhone = phone ? parsePhoneNumber(phone) : '';

  if (!parsedPhone) {
    return null;
  }

  return (
    <span className={styles['phone']} data-testid="PrintPhone">
      {parsedPhone}
    </span>
  );
};
